import { Routes } from '@angular/router';

export const routes: Routes = [
  //{ path: '', redirectTo: '', pathMatch: 'full' },
  { path: '', loadChildren: () => import('./core/auth/auth.routes').then((mod) => mod.AUTH_ROUTES) },
  {
    path: 'admins',
    loadChildren: () => import('./features/admin/admin.routes').then((mod) => mod.ADMIN_ROUTES),
  },
  {
    path: 'candidates',
    loadChildren: () => import('./features/candidate/candidate.routes').then((mod) => mod.CANDIDATE_ROUTES),
  },
  {
    path: 'organizations',
    loadChildren: () => import('./features/organization/organization.routes').then((mod) => mod.ORGANIZATION_ROUTES),
  },
  { path: 'users', loadChildren: () => import('./core/user/user.routes').then((mod) => mod.USER_ROUTES) },
  { path: '**', redirectTo: '/not-found' },
];
